import produce from 'immer'

import {
  FETCH_VERTICALS,
  FETCH_VERTICALS_SUCCESS,
  FETCH_VERTICALS_FAILURE,
  FETCH_SELENE_VERSIONS,
  FETCH_SELENE_VERSIONS_SUCCESS,
  FETCH_SELENE_VERSIONS_FAILURE,
  FETCH_TEMPLATE_TYPES,
  FETCH_TEMPLATE_TYPES_SUCCESS,
  FETCH_TEMPLATE_TYPES_FAILURE,
  FETCH_VERTICAL_STATUS,
  FETCH_VERTICAL_STATUS_SUCCESS,
  FETCH_VERTICAL_STATUS_FAILURE,
  FETCH_VERTICAL_PROGRESS,
  FETCH_VERTICAL_PROGRESS_SUCCESS,
  FETCH_VERTICAL_PROGRESS_FAILURE,
  REINDEX_VERTICAL,
  REINDEX_VERTICAL_SUCCESS,
  REINDEX_VERTICAL_FAILURE,
  STOP_SELENE_REINDEX,
  STOP_SELENE_REINDEX_SUCCESS,
  STOP_SELENE_REINDEX_FAILURE,
  REINDEX_SELENE_BY_ID,
  REINDEX_SELENE_BY_ID_SUCCESS,
  REINDEX_SELENE_BY_ID_FAILURE,
  SET_SELENE_VERSIONS,
  SET_SELENE_VERSIONS_SUCCESS,
  SET_SELENE_VERSIONS_FAILURE,
  SET_TEMPLATE_TYPES,
} from '../actions/types'

export const initialProgressStatusState = {
  message: '',
  running: false,
  error: false,
  progress: 0,
  total: 0,
  finished: false,
  cancelled: false,
}

export const initialVerticalState = {
  fullName: '',
  vertical: '',
  indexName: false,
  providers: [],
  indexedCount: 0,
  totalCount: 0,
  percentage: 0,
  progressStatus: initialProgressStatusState,

  statusFetching: false,
  statusFetched: false,
  statusError: null,

  progressFetching: false,
  progressFetched: false,
  progressError: null,
}

export const initialState = {
  verticalsAllIds: [],
  verticalsById: {},
  verticalsFetching: false,
  verticalsFetched: false,
  verticalsError: null,

  templateTypes: [],
  selectedTemplateTypes: [],
  templateTypesFetching: false,
  templateTypesFetched: false,
  templateTypesError: null,

  versions: [],
  versionsFetching: false,
  versionsFetched: false,
  versionsError: null,

  reindexVerticalPending: false,
  reindexVerticalSuccess: false,
  reindexVerticalError: null,

  stopReindexPending: false,
  stopReindexSuccess: false,
  stopReindexError: null,

  reindexByIdPending: false,
  reindexByIdSuccess: false,
  reindexByIdError: null,

  setVersionsPending: false,
  setVersionsSuccess: false,
  setVersionsError: null,
}

export default produce((draft, action) => {
  const { type, payload } = action || {}

  switch (type) {
    case FETCH_VERTICALS: {
      draft.verticalsFetching = true
      break
    }
    case FETCH_VERTICALS_SUCCESS: {
      const verticals = payload
      draft.verticalsError = null
      draft.verticalsFetching = false
      draft.verticalsFetched = true
      draft.verticalsAllIds = []
      draft.verticalsById = {}
      verticals.forEach((vertical) => {
        draft.verticalsAllIds.push(vertical.vertical)
        draft.verticalsById[vertical.vertical] = { ...initialVerticalState, ...vertical }
      })
      break
    }
    case FETCH_VERTICALS_FAILURE: {
      const error = payload
      draft.verticalsError = error
      draft.verticalsFetching = false
      draft.verticalsFetched = true
      break
    }
    case FETCH_SELENE_VERSIONS: {
      draft.versionsFetching = true
      break
    }
    case FETCH_SELENE_VERSIONS_SUCCESS: {
      const versions = payload
      draft.versionsError = null
      draft.versionsFetching = false
      draft.versionsFetched = true
      draft.versions = versions
      break
    }
    case FETCH_SELENE_VERSIONS_FAILURE: {
      const error = payload
      draft.versionsError = error
      draft.versionsFetching = false
      draft.versionsFetched = true
      break
    }
    case FETCH_TEMPLATE_TYPES: {
      draft.templateTypesFetching = true
      break
    }
    case FETCH_TEMPLATE_TYPES_SUCCESS: {
      const templateTypes = payload
      draft.templateTypesError = null
      draft.templateTypesFetching = false
      draft.templateTypesFetched = true
      draft.templateTypes = templateTypes
      break
    }
    case FETCH_TEMPLATE_TYPES_FAILURE: {
      const error = payload
      draft.templateTypesError = error
      draft.templateTypesFetching = false
      draft.templateTypesFetched = true
      break
    }
    case FETCH_VERTICAL_STATUS: {
      const { verticalName } = payload
      const vertical = draft.verticalsById[verticalName]
      vertical.statusFetching = true
      break
    }
    case FETCH_VERTICAL_STATUS_SUCCESS: {
      const { verticalName, data } = payload
      const { indexedCount, totalCount, percentage, progressStatus } = data
      const vertical = draft.verticalsById[verticalName]
      vertical.statusError = null
      vertical.statusFetching = false
      vertical.statusFetched = true

      vertical.indexedCount = indexedCount
      vertical.totalCount = totalCount
      vertical.percentage = percentage
      vertical.progressStatus = progressStatus
      break
    }
    case FETCH_VERTICAL_STATUS_FAILURE: {
      const { verticalName, error } = payload
      const vertical = draft.verticalsById[verticalName]
      vertical.statusError = error
      vertical.statusFetching = false
      vertical.statusFetched = true
      break
    }
    case FETCH_VERTICAL_PROGRESS: {
      const verticalName = payload
      const vertical = draft.verticalsById[verticalName]
      vertical.progressFetching = true
      break
    }
    case FETCH_VERTICAL_PROGRESS_SUCCESS: {
      const { verticalName, data } = payload
      const { message, running, error, progress, total, finished, cancelled } = data
      const vertical = draft.verticalsById[verticalName]
      vertical.progressError = null
      vertical.progressFetching = false
      vertical.progressFetched = true
      vertical.progressStatus = {}
      vertical.progressStatus.message = message
      vertical.progressStatus.running = running
      vertical.progressStatus.error = error
      vertical.progressStatus.progress = progress
      vertical.progressStatus.total = total
      vertical.progressStatus.finished = finished
      vertical.progressStatus.cancelled = cancelled
      break
    }
    case FETCH_VERTICAL_PROGRESS_FAILURE: {
      const { verticalName, error } = payload
      const vertical = draft.verticalsById[verticalName]
      vertical.progressError = error
      vertical.progressFetching = false
      vertical.progressFetched = true
      break
    }
    case REINDEX_VERTICAL: {
      draft.reindexVerticalPending = true
      break
    }
    case REINDEX_VERTICAL_SUCCESS: {
      draft.reindexVerticalError = null
      draft.reindexVerticalPending = false
      draft.reindexVerticalSuccess = true
      break
    }
    case REINDEX_VERTICAL_FAILURE: {
      const { error } = payload
      draft.reindexVerticalError = error
      draft.reindexVerticalPending = false
      draft.reindexVerticalSuccess = false
      break
    }
    case STOP_SELENE_REINDEX: {
      draft.stopReindexPending = true
      break
    }
    case STOP_SELENE_REINDEX_SUCCESS: {
      draft.stopReindexError = null
      draft.stopReindexPending = false
      draft.stopReindexSuccess = true
      break
    }
    case STOP_SELENE_REINDEX_FAILURE: {
      const { error } = payload
      draft.stopReindexError = error
      draft.stopReindexPending = false
      draft.stopReindexSuccess = false
      break
    }
    case REINDEX_SELENE_BY_ID: {
      draft.reindexByIdPending = true
      break
    }
    case REINDEX_SELENE_BY_ID_SUCCESS: {
      draft.reindexByIdError = null
      draft.reindexByIdPending = false
      draft.reindexByIdSuccess = true
      break
    }
    case REINDEX_SELENE_BY_ID_FAILURE: {
      const error = payload
      draft.reindexByIdError = error
      draft.reindexByIdPending = false
      draft.reindexByIdSuccess = false
      break
    }
    case SET_SELENE_VERSIONS: {
      draft.setVersionsPending = true
      break
    }
    case SET_SELENE_VERSIONS_SUCCESS: {
      draft.setVersionsError = null
      draft.setVersionsPending = false
      draft.setVersionsSuccess = true
      break
    }
    case SET_SELENE_VERSIONS_FAILURE: {
      const error = payload
      draft.setVersionsError = error
      draft.setVersionsPending = false
      draft.setVersionsSuccess = false
      break
    }
    case SET_TEMPLATE_TYPES: {
      draft.selectedTemplateTypes = payload
      break
    }
    default:
      // Nothing to do
      break
  }
}, initialState)
